import apiClient from './api';

const filenameFrom = (contentDisposition, fallback) => {
  if (!contentDisposition) return fallback;
  const utf8 = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8) return decodeURIComponent(utf8[1]);
  const plain = contentDisposition.match(/filename="?([^";]+)"?/i);
  return plain ? plain[1] : fallback;
};

export const saveBlob = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

const serverMessage = async (data) => {
  try {
    const text = typeof data?.text === 'function' ? await data.text() : null;
    return text ? JSON.parse(text).message || null : null;
  } catch {
    return null;
  }
};

const errorMessage = async (error, what) => {
  if (error.response?.status === 403) return 'You do not have permission to export data';
  if (error.response?.status === 400) return (await serverMessage(error.response.data)) || `Failed to export ${what}`;
  return `Failed to export ${what}`;
};

/**
 * Downloads a file response through the shared apiClient so the MSAL or Testing token is attached.
 * path is relative to /api, for example "/export/datasets/Calls".
 */
export const downloadExport = async (path, params = {}, fallbackFilename = 'export.csv') => {
  try {
    const response = await apiClient.get(path, { params, responseType: 'blob' });
    const filename = filenameFrom(response.headers['content-disposition'], fallbackFilename);
    saveBlob(response.data, filename);
    return { success: true, filename };
  } catch (error) {
    console.error(`Export ${path} failed:`, error.response?.status || error.message);
    return { success: false, error: await errorMessage(error, fallbackFilename) };
  }
};

/** POST export/table: the server renders a table the page already shows (admin lists) as a workbook. */
export const downloadTableExport = async (table, fallbackFilename = 'export.xlsx') => {
  try {
    const response = await apiClient.post('/export/table', table, { responseType: 'blob' });
    const filename = filenameFrom(response.headers['content-disposition'], fallbackFilename);
    saveBlob(response.data, filename);
    return { success: true, filename };
  } catch (error) {
    console.error('Export export/table failed:', error.response?.status || error.message);
    return { success: false, error: await errorMessage(error, fallbackFilename) };
  }
};
